import { QUERY_KEYS } from '../api/querykeys'
import { LabAppointments as LabAppointmentsRoute } from '../api/routes'
import { useQuery } from 'react-query'
import { useAlertContext } from '../context/AlertContext'
import { useSourcePluginContext } from '../context/SourcePluginContext'
import { LabAppointment } from '../types/types'

interface UseLabAppointmentsInterface {
  labAppointments: LabAppointment[]
  isLoading: boolean
  error: unknown
  isSuccess: boolean
}

const useLabAppointments = (member?: string): UseLabAppointmentsInterface => {
  const { setAlertText } = useAlertContext()
  const { getAuthHeader } = useSourcePluginContext()

  const fetchLabAppointments = async (): Promise<LabAppointment[]> => {
    if (!member) {
      return []
    }

    const authHeader = await getAuthHeader()
    return fetch(
      `${process.env.REACT_APP_SERVER_URL}${LabAppointmentsRoute(member)}`,
      { headers: authHeader }
    )
      .then(async (res) => {
        const data = await res.json()

        if (res.ok) {
          return data
        } else if (res.status === 403) {
          setAlertText('Unauthorized - you may need to reload the page')
          return []
        } else {
          setAlertText(`Error loading lab appointments (${res.statusText})`)
          return []
        }
      })
      .catch(() => {
        setAlertText(`Error loading lab appointments`)
        return []
      })
  }

  const {
    data: labAppointments,
    isLoading,
    error,
    isSuccess,
  } = useQuery(
    [QUERY_KEYS.LAB_APPOINTMENTS, member ?? 'default'],
    fetchLabAppointments
  )

  return {
    labAppointments: labAppointments ?? [],
    isLoading,
    error,
    isSuccess,
  }
}

export default useLabAppointments
